import type { Choice } from "@memorang/types";
import Box from "../../../Box";

import DraggableFlatList, {
	ScaleDecorator,
	type RenderItemParams,
} from "react-native-draggable-flatlist";
import { Button } from "react-native-paper";

export type DraggableListProps = {
	items: Choice[];
	onReorder: (newItems: Choice[]) => void;
	renderItem: (
		item: Choice,
		index: number,
		drag: () => void,
	) => React.ReactNode;
	answered?: boolean;
	handleSkip?: () => void;
};

export const DraggableList = ({
	items,
	onReorder,
	renderItem,
	answered,
	handleSkip,
}: DraggableListProps) => {
	return (
		<Box gap={16}>
			<DraggableFlatList
				data={items}
				onDragEnd={({ data }) => onReorder(data)}
				scrollEnabled={false}
				keyExtractor={(item) => item.id}
				renderItem={({ item, drag, getIndex }: RenderItemParams<Choice>) => (
					<ScaleDecorator activeScale={1.05}>
						{renderItem(item, getIndex() || 0, drag)}
					</ScaleDecorator>
				)}
				contentContainerStyle={{
					gap: 16,
				}}
			/>
			{!answered && handleSkip && (
				<Box alignSelf="flex-end">
					<Button onPress={handleSkip}>Skip</Button>
				</Box>
			)}
		</Box>
	);
};
